import { render, staticRenderFns } from "./ProduccionAYBForm.vue?vue&type=template&id=98403f6c"
import script from "./ProduccionAYBForm.vue?vue&type=script&lang=js"
export * from "./ProduccionAYBForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports